import 'core-js'
import 'airbnb-browser-shims'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import configureStore from './reducers/configuration/store'
import App from './containers/App'

import './styles/css/base/normalize.css'
import './styles/css/base/base.css'
import './styles/css/vendor/flexboxgrid.css'
import './styles/css/base/flexboxgrid-overrides.css'
import './styles/css/base/mui-overrides.css'
import './styles/css/base/typography.css'
import './styles/css/base/buttons.css'
import './styles/css/base/utilities.css'
import './styles/css/base/calendar.css'
import './styles/css/base/forms.css'
import './styles/css/theme/theme-base.css'
import fetchConfiguration from '../src/actions/fetchConfiguration'
import WebFont from 'webfontloader'

WebFont.load({
	google: {
		families: ['Material Icons']
	}
})

const store = configureStore()
store.dispatch(fetchConfiguration())

const renderApp = () =>
	render(
		<Provider store={store}>
			<App />
		</Provider>,
		document.getElementById('bk-flow')
	)

	if (process.env.NODE_ENV !== 'production' && module.hot) {
		module.hot.accept('./containers/App', renderApp)
	}

renderApp()


// WEBPACK FOOTER //
// ./src/index.js